import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-slant-gradient",
  "use": "icon-slant-gradient-usage",
  "viewBox": "0 0 574.3 250.5",
  "content": "<symbol preserveAspectRatio=\"none\" viewBox=\"0 0 574.3 250.5\" id=\"icon-slant-gradient\">\r\n    <linearGradient id=\"icon-slant-gradient_SVGID_1_\" gradientUnits=\"userSpaceOnUse\" x1=\"0\" y1=\"125.25\" x2=\"574.3\" y2=\"125.25\">\r\n        <stop offset=\"0\" style=\"stop-color:#61259E\" />\r\n        <stop offset=\"1\" style=\"stop-color:#43509E\" />\r\n    </linearGradient>\r\n    <path style=\"fill: url(#icon-slant-gradient_SVGID_1_)\" d=\"M574.3,0v214.5L0,250.5V144.7V0h239.9H574.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/slant-gradient.svg
// module id = JqIc
// module chunks = 0